import curry from "../../lib/core/functional/curry";
import { doUpgradeToLoggedIn } from "../../upgradeToLoggedInLoader";

import { loginRequest } from "../../transport/loginSignupV2";
import { isEmail } from "../../utils/validations";


function toggleMFALoginForms(wrapper) {
    const loginBox = wrapper.closest(".login-signup-wrapper");
    const loginForm = loginBox.querySelector('.comment--login');
    const otpForm = loginBox.querySelector('.comment--otp');

    loginForm.classList.toggle('hidden');
    otpForm.classList.toggle('hidden');
}

const checkForMFA = curry(function checkForMFA(wrapper, context, response){
    if (response.is_otp_verification_requested) {
        toggleMFALoginForms(wrapper);
    } else {
        const loginBox = wrapper.closest(".login-signup-wrapper");
        loginBox.parentNode.removeChild(loginBox);
        doUpgradeToLoggedIn(context);
    }
})

export const loginAction = curry((context, event) => {
    const wrapper = event.currentTarget;
    const email = wrapper.querySelector("#id_email").value.trim();
    const password = wrapper.querySelector("#id_password").value.trim();
    const errorContainer = wrapper.querySelector(".comment--login--message.error");
    errorContainer.classList.add("hidden");

    if (_validateLogin(wrapper, email, password)) {
        event.preventDefault();
        loginRequest({ email, password }, document.location.search)
            .then(checkForMFA(wrapper, context))
            .catch((error) => {
                errorContainer.classList.remove("hidden");
                errorContainer.textContent = error.message;
            });
        return false;
    }
});

const _validateLogin = (wrapper, email, password) => {
    const emailElement = wrapper.querySelector("#id_email");
    const passwordElement = wrapper.querySelector("#id_password");
    const requirementElement = wrapper.querySelector(".comment--login-form .requirements");
    emailElement.classList.toggle("required", !isEmail(email));
    passwordElement.classList.toggle("required", !password);

    var isValid = !(!isEmail(email) || !password);
    requirementElement.classList.toggle("hidden", isValid);
    if (requirementElement.classList.contains("hidden")) {
        emailElement.setAttribute("placeholder", "* Enter your email");
        passwordElement.setAttribute("placeholder", "* Enter your password");
    }
    return isValid;
};
